import { api } from '@goaltree/backend/convex/_generated/api'
import type { Id } from '@goaltree/backend/convex/_generated/dataModel'
import { useNavigate } from '@tanstack/react-router'
import { useMutation } from 'convex/react'
import { useTranslation } from 'react-i18next'
import { toast } from 'sonner'

export function useSaveAsTemplate() {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const save = useMutation(api.templates.saveGoalAsTemplate)
  return async (goalId: Id<'nodes'>) => {
    try {
      await save({ goalId })
      toast.success(t('templates.saved'), {
        action: {
          label: t('templates.view'),
          onClick: () =>
            void navigate({ to: '/explore', search: { tab: 'templates', mine: true } }),
        },
      })
    } catch {
      toast.error(t('templates.saveFailed'))
    }
  }
}
